import { render, staticRenderFns } from "./DoneFormsEnrollmentCounters.vue?vue&type=template&id=61a230c1&"
import script from "./DoneFormsEnrollmentCounters.vue?vue&type=script&lang=js&"
export * from "./DoneFormsEnrollmentCounters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports